import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";

interface RosterSwitchConfirmDialogProps {
  confirming: boolean;
  mountNode: HTMLElement | null;
  officeName: string;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  open: boolean;
}

export const RosterSwitchConfirmDialog = ({
  confirming,
  mountNode,
  officeName,
  onCancel,
  onConfirm,
  open,
}: RosterSwitchConfirmDialogProps) => {
  const handleConfirm = useStableCallback(async () => {
    await onConfirm();
  });
  const handleOpenChange39 = useStableCallback((_event, data) => {
    if (!data.open) {
      onCancel();
    }
  });

  if (!open) {
    return null;
  }

  return (
    <Dialog onOpenChange={handleOpenChange39} open={open}>
      <DialogSurface data-roster mountNode={mountNode}>
        <DialogBody>
          <DialogTitle>Switch office</DialogTitle>
          <DialogContent>Do you want to switch to {officeName}?</DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              disabled={confirming}
              onClick={onCancel}
              type="button"
            >
              Cancel
            </Button>
            <Button
              appearance="primary"
              disabled={confirming}
              onClick={handleConfirm}
              type="button"
            >
              {confirming ? "Switching..." : "Switch"}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
